import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roleLabel',
  standalone: true
})
export class RoleLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    switch (value) {
      case 'ADMIN_ROLE':
        return 'Admin';
      case 'VENDOR_ROLE':
        return 'Venditore';
      case 'TECHNICIAN_ROLE':
        return 'Tecnico';
      default:
        return value;
    }
  }
}


